import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { globalRequirementTemplateBuilder } from '../../../../../redux/reducer';
import TemplateListPanel from '../TemplateListPanel';

const DraftTemplatesListPanel = () => {
  const dispatch = useDispatch();

  const { data: requirementTemplates, ...pageInfo } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplates);

  const fetchNext = () => {
    dispatch(globalRequirementTemplateBuilder.listDraftedRequirementTemplates({
      pageNumber: pageInfo.currentPage + 1,
      pageSize: 25
    }));
  };

  useEffect(() => {
    dispatch(globalRequirementTemplateBuilder.listDraftedRequirementTemplates());
  }, []);

  return (
    <TemplateListPanel
      draft
      fetchNext={fetchNext}
      pageInfo={pageInfo}
      templates={requirementTemplates}
    />
  );
};

export default DraftTemplatesListPanel;
